import { render, staticRenderFns } from "./VideoComment.vue?vue&type=template&id=7367b0aa&scoped=true&"
import script from "./VideoComment.vue?vue&type=script&lang=js&"
export * from "./VideoComment.vue?vue&type=script&lang=js&"
import style0 from "./VideoComment.vue?vue&type=style&index=0&id=7367b0aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7367b0aa",
  null
  
)

export default component.exports